import { useLayoutEffect, useState, useEffect, useMemo } from 'react';
import logo from '@images/cc.png';
import top_bg from '@images/megax-header.png';
import ic_untick from '@images/ccc.png';
import ic_tick from '@images/cccc.png';
import ic_fb from '@images/ic_fb.png';
import ic_tele from '@images/ic_tele.png';
import ic_wat from '@images/ic_wat.png';
import ic_in from '@images/ic_in.png';
import ic_gg from '@images/ic_gg.png';
import ic_login from '@images/login.png';
import ic_menu from '@images/ic_menu.png';
import { makeStyles } from '@mui/styles';
import { AspectRatio } from 'react-aspect-ratio';
import { debounce } from 'lodash';
import example from '@images/example.png';
import Marquee from 'react-fast-marquee';
import { FiSearch } from 'react-icons/fi';
import {
  getSumAPI,
  listIdea,
  listIdeaCategorys,
  listIdeaSupporters,
} from '@sdk/managers/IdeaManager';
import Loader from '@components/elements/Loader';
import { getImageUrl } from '@utils/image';
import { useHistory } from 'react-router-dom';
import { useAuth } from '@hooks/Auth';
import InputText from '@components/elements/InputText';
import { listPublicPolls } from '@sdk/managers/PollsManager';
import { PollStatus } from '@sdk/API';

import PollList, { PollListProps } from '@components/elements/PollList';
import { formatPollData, FormattedPoll } from '@utils/Poll';
import useSWR from 'swr';
import { listHotPledges } from '@sdk/managers/PledgesManager';
import {
  addMonths,
  endOfMonth,
  format,
  isSameMonth,
  isWithinInterval,
  startOfMonth,
  subMonths,
} from 'date-fns';
import PollPledgeIcon from '@components/modules/Poll/PollPledgeIcon';

const POLL_FIELDS = [
  {
    items: [
      'companyID',
      { company: ['name'] },
      'id',
      'title',
      'description',
      'category',
      'hashtag',
      'hasPledge',
      'status',
      'owner',
      'startTime',
      'endTime',
      'password',
      'private',
      {
        image: ['key', 'bucket', 'region'],
      },
      'pledgePeriod1StartTime',
      'pledgePeriod1EndTime',
      'video',
      'createdAt',
      {
        options: ['id', 'description'],
      },
      { voteResults: [{ items: ['count'] }] },
    ],
  },
  'nextToken',
];
const countTotalVote = (data: any[]) => {
  let total = 0;

  data.forEach((d: any) => {
    total += d.count;
  });

  return total;
};

const useStyles = makeStyles({
  cinput: {
    width: '100%',
    padding: ' 9px 4px 9px 40px',
    maxWidth: 920,
    borderRadius: 50,
    position: 'relative',
    zIndex: 99999999,
    border: 'none',
    marginTop: 20,
    height: 100,
    fontSize: 50,
    '@media (max-width: 768px)': {
      height: 40,
      fontSize: 18,
    },
  },
  searchTitle: {
    fontSize: ' 5rem' /* 24px */,
    lineHeight: '5rem' /* 32px */,
    '@media (max-width: 768px)': {
      fontSize: ' 1.5rem' /* 24px */,
      lineHeight: ' 2rem' /* 32px */,
    },
  },
  borderText: {
    'text-shadow':
      'rgb(255, 70, 255) 2px 0px 0px, rgb(255, 70, 255) 1.75517px 0.958851px 0px, rgb(255, 70, 255) 1.0806px 1.68294px 0px, rgb(255, 70, 255) 0.141474px 1.99499px 0px, rgb(255, 70, 255) -0.832294px 1.81859px 0px, rgb(255, 70, 255) -1.60229px 1.19694px 0px, rgb(255, 70, 255) -1.97998px 0.28224px 0px, rgb(255, 70, 255) -1.87291px -0.701566px 0px, rgb(255, 70, 255) -1.30729px -1.5136px 0px, rgb(255, 70, 255) -0.421592px -1.95506px 0px, rgb(255, 70, 255) 0.567324px -1.91785px 0px, rgb(255, 70, 255) 1.41734px -1.41108px 0px, rgb(255, 70, 255) 1.92034px -0.558831px 0px',
  },

  tag: {
    '@media (max-width: 1280px)': {
      marginTop: '120px !important',
    },
  },
  prod: {
    width: '100%',
    minWidth: 120,
    borderRadius: 8,
    aspectRatio: 1.32,
    objectFit: 'cover',
  },
  prodContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: ' 20px',
    '@media (max-width: 1280px)': {
      gridTemplateColumns: 'repeat(3, 1fr)',
    },
    '@media (max-width: 920px)': {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    // '@media (max-width: 400px)': {
    //   gridTemplateColumns: 'repeat(1, 1fr)',
    // },
  },
  cContainer: {
    width: '100%',
    position: 'relative',
    maxWidth: 1536,
  },
  cButton: {
    background: 'transparent',
    border: '2px solid white',
    padding: '4px 16px',
    color: 'white',
    fontWeight: '400',
    '&:hover': {
      background: 'pink',
    },
  },
  card: {
    padding: '34px 0',
  },
  topTitle: {
    opacity: 1,
    color: 'white',
    fontSize: '60px',
    lineHeight: '70px',
    fontWeight: 700,
    '@media (max-width: 640px)': {
      fontSize: '18px',
      lineHeight: '20px',
    },
  },
  topContent: {
    '@media (max-width: 640px)': {
      fontSize: '14px',
      lineHeight: '16px',
    },
  },

  content: {
    width: '100%',
    position: 'relative',
    maxWidth: 1536,
    padding: 25,
    paddingBottom: 200,
    '@media (max-width: 640px)': {
      padding: 20,
      paddingBottom: 150,
    },
  },
  sort: {
    borderRadius: 16,
    border: '2px solid black',
    opacity: 1,
    maxWidth: 450,
    width: '100%',
    height: 60,
    padding: '0 10px',
    fontSize: 28,
    fontWeight: 700,
    '@media (max-width: 768px)': {
      height: 50,
      fontSize: 18,
    },

    // backgroundImage: `url(${arrown})`,
    // backgroundRepeat: 'no-repeat',
    // backgroundPosition: ' 98% center',
  },
  prodTitle: {
    fontSize: 28,
    fontWeight: 700,
    wordBreak: 'break-all',
    height: 54,
    display: ' -webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: 10,
    color: 'black',
    '@media (max-width: 768px)': {
      fontSize: 18,
    },
    '@media (max-width: 400px)': {
      fontSize: 14,
      height: 34,
    },
  },
  prodTime: {
    fontSize: 18,
    fontWeight: 700,
    height: 54,
    display: ' -webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: 10,
    color: 'black',
    '@media (max-width: 768px)': {
      fontSize: 18,
    },
    '@media (max-width: 400px)': {
      height: 54,
      fontSize: 14,
    },
  },
  furetureTitle: {
    fontSize: 40,
    lineHeight: '47px',
    fontWeight: 700,
    marginBottom: 20,

    '@media (max-width: 768px)': {
      fontSize: 28,
    },
    '@media (max-width: 400px)': {
      fontSize: 18,
    },
  },
  topCard: {
    marginTop: 200,
    border: '3px solid #FEC411',
    boxShadow: '10px 8px 0px 2px #FEC411',
    background: 'black',
    borderRadius: 4,
    color: 'white',
    '@media (max-width: 640px)': {
      marginTop: 50,
    },
  },
  sponsor: {
    borderRadius: ' 3px',
    border: '2px solid rgba(254,196,17, 1)',
    boxShadow: '5px -6px 0px rgba(254,196,17, 1)',
    opacity: 1,
    backgroundColor: 'rgba(255,255,255, 1)',
    position: 'fixed',
    height: 'max-content',
    left: 40,
    right: 40,
    bottom: 40,
    padding: '20px 55px',
    gap: 55,
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 640px)': {
      left: 20,
      right: 20,
      padding: '20px 20px',
      gap: 20,
    },
  },
  sponsorItem: {
    cursor: 'pointer',
    width: 124,
    height: 124,
    minWidth: 124,
    margin: '0 20px',

    '@media (max-width: 640px)': {
      width: 60,
      minWidth: 60,
      height: 60,
    },
  },
  sponContainer: {
    overflowY: 'hidden',
    gap: 60,
    '@media (max-width: 640px)': {
      gap: 20,
    },
  },
});

const ListIdea = () => {
  const classes = useStyles();
  const [categories, setCategories] = useState<{ title: string; id: string }[]>(
    []
  );
  const [selectCategory, setSelectCategory] = useState<any>({});
  const { dbUser, company } = useAuth();
  const history = useHistory();
  const [list, setList] = useState<any[]>();
  const [search, setSearch] = useState('');
  const [info, setInfo] = useState({ ideas: 0, pledges: 0, sponsors: 0 });
  const [typing, setTyping] = useState(false);
  const [suppoters, setSuppoters] = useState([]);
  const navigateUrl = (url: string) => {
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    } else {
      return 'http://' + url;
    }
  };
  const getHotPledgesData = async (
    _query: string,
    date: Date,
    companyId?: string,
    grc?: string,
    division?: string
  ) => {
    let companyFilters = companyId
      ? {
          or: [
            { companyID: { eq: companyId } },
            { companyID: { attributeExists: false } },
          ],
        }
      : { companyID: { attributeExists: false } };

    let locationFilters =
      grc && division
        ? {
            and: [
              {
                or: [{ grc: { attributeExists: false } }, { grc: { eq: grc } }],
              },
              {
                or: [
                  { division: { attributeExists: false } },
                  { division: { eq: division } },
                ],
              },
            ],
          }
        : {
            and: [
              { grc: { attributeExists: false } },
              { division: { attributeExists: false } },
            ],
          };

    const filters = {
      filter: {
        status: { eq: PollStatus.PLEDGING1 },

        ...locationFilters,
      },
    };
    const filtersd = {
      filter: {
        status: { eq: PollStatus.PLEDGING1 },
        ...companyFilters,
        ...locationFilters,
      },
    };
    let polls: any[] = [];
    let nextToken;
    do {
      const res: any = await listPublicPolls(
        POLL_FIELDS,
        filters,
        0,
        nextToken
      );
      if (res.data?.result.items) polls = polls.concat(res.data.result.items);
      nextToken = res.data?.result.nextToken;
    } while (nextToken);

    do {
      const res: any = await listPublicPolls(
        POLL_FIELDS,
        filtersd,
        2,
        nextToken
      );
      if (res.data?.result.items) polls = polls.concat(res.data.result.items);
      nextToken = res.data?.result.nextToken;
    } while (nextToken);

    let formattedPolls = await Promise.all<FormattedPoll>(
      polls.map((item: any) => formatPollData(item))
    );
    console.log();
    formattedPolls = formattedPolls.filter((poll) => {
      return +new Date(poll.startDate) === +new Date(poll.endDate);
    });

    formattedPolls.sort((a, b) => {
      return b.createdAt && a.createdAt
        ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        : 0;
    });

    return formattedPolls;
  };

  const getFeedData = async (
    _query: string,
    date: Date,
    companyId?: string,
    grc?: string,
    division?: string
  ) => {
    const filterStartMonth = startOfMonth(date);
    const filterEndMonth = endOfMonth(date);

    let companyFilters = companyId
      ? {
          or: [
            { companyID: { eq: companyId } },
            { companyID: { attributeExists: false } },
          ],
        }
      : { companyID: { attributeExists: false } };

    let locationFilters =
      grc && division
        ? {
            and: [
              {
                or: [{ grc: { attributeExists: false } }, { grc: { eq: grc } }],
              },
              {
                or: [
                  { division: { attributeExists: false } },
                  { division: { eq: division } },
                ],
              },
            ],
          }
        : {
            and: [
              { grc: { attributeExists: false } },
              { division: { attributeExists: false } },
            ],
          };

    const filters = {
      filter: {
        status: { ne: PollStatus.CLOSED },

        ...locationFilters,
        endTime: {
          ge: filterStartMonth.toISOString(),
        },
      },
    };
    const filtersD = {
      filter: {
        status: { ne: PollStatus.CLOSED },
        ...companyFilters,
        ...locationFilters,
        endTime: {
          ge: filterStartMonth.toISOString(),
        },
      },
    };
    let polls: any[] = [];
    let nextToken;
    do {
      const res: any = await listPublicPolls(
        POLL_FIELDS,
        filters,
        0,
        nextToken
      );
      if (res.data?.result.items) polls = polls.concat(res.data.result.items);
      nextToken = res.data?.result.nextToken;
    } while (nextToken);

    do {
      const res: any = await listPublicPolls(
        POLL_FIELDS,
        filtersD,
        2,
        nextToken
      );
      if (res.data?.result.items) polls = polls.concat(res.data.result.items);
      nextToken = res.data?.result.nextToken;
    } while (nextToken);

    let formattedPolls = await Promise.all<FormattedPoll>(
      polls.map((item: any) => formatPollData(item))
    );

    formattedPolls = formattedPolls.filter((poll) => {
      if (
        poll.status === 'CLOSED' ||
        +new Date() >= +new Date(poll.endDate) ||
        +new Date(poll.startDate) === +new Date(poll.endDate)
      ) {
        return false;
      }

      // Starts this month
      if (
        isWithinInterval(poll.startDate, {
          start: filterStartMonth,
          end: filterEndMonth,
        })
      ) {
        return true;
      }

      // Ongoing at start of month
      return isWithinInterval(filterStartMonth, {
        start: poll.startDate,
        end: poll.endDate,
      });
    });

    formattedPolls.sort((a, b) => {
      return b.createdAt && a.createdAt
        ? new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        : 0;
    });

    return formattedPolls;
  };
  const [dates, setDates] = useState([]);
  const listMonth = () => {
    const datecs: any = [];
    let current = subMonths(new Date(), 11);
    for (let i = 0; i < 12; i++) {
      datecs.unshift(current);
      current = addMonths(current, 1);
    }
    setDates(datecs);
  };

  const getHotPollData = async (
    _query: string,
    companyId?: string,
    grc?: string,
    division?: string
  ) => {
    const now = new Date();

    let companyFilters = companyId
      ? {
          or: [
            { companyID: { eq: companyId } },
            { companyID: { attributeExists: false } },
          ],
        }
      : { companyID: { attributeExists: false } };

    let locationFilters =
      grc && division
        ? {
            and: [
              {
                or: [{ grc: { attributeExists: false } }, { grc: { eq: grc } }],
              },
              {
                or: [
                  { division: { attributeExists: false } },
                  { division: { eq: division } },
                ],
              },
            ],
          }
        : {
            and: [
              { grc: { attributeExists: false } },
              { division: { attributeExists: false } },
            ],
          };
    const filters = {
      filter: {
        status: { ne: PollStatus.CLOSED },
        ...companyFilters,
        ...locationFilters,
        endTime: {
          ge: now.toISOString(),
        },
        startTime: {
          le: now.toISOString(),
        },
      },
    };
    let polls: any[] = [];
    let nextToken;
    do {
      const res: any = await listPublicPolls(
        POLL_FIELDS,
        filters,
        0,
        nextToken
      );
      if (res.data?.result.items) polls = polls.concat(res.data.result.items);
      nextToken = res.data?.result.nextToken;
    } while (nextToken);

    do {
      const res: any = await listPublicPolls(
        POLL_FIELDS,
        filters,
        2,
        nextToken
      );
      if (res.data?.result.items) polls = polls.concat(res.data.result.items);
      nextToken = res.data?.result.nextToken;
    } while (nextToken);

    let formattedPolls = (await Promise.all(
      polls.map(async (item: any) => {
        const data = {
          ...item,
          votes: countTotalVote(item.voteResults.items),
        };
        return formatPollData(data);
      })
    )) as FormattedPoll[];

    formattedPolls = formattedPolls.filter((poll) => {
      if (poll.status === 'CLOSED') {
        return false;
      }

      return true;
    });

    formattedPolls.sort((a: FormattedPoll, b: FormattedPoll) => {
      return (
        (b.voteCount || 0) - (a.voteCount || 0) ||
        new Date(b.startDate).getTime() - new Date(a.startDate).getTime()
      );
    });

    return formattedPolls;
  };
  const randomIndex = useMemo(() => Math.floor(Math.random() * 3), []);

  const [filterDate, setFilterDate] = useState<Date>(new Date());
  const [sort, setSort] = useState(0);
  // const hotPoll = useSWR<FormattedPoll[]>(
  //   [
  //     '/poll/hot',
  //     company?.companyID,
  //     dbUser?.postalInfo?.grc,
  //     dbUser?.postalInfo?.division,
  //   ],
  //   getHotPollData
  // );
  const hotPoll = useSWR(
    [
      '/poll/hot/pledge',
      filterDate,
      company?.companyID,
      dbUser?.postalInfo?.grc,
      dbUser?.postalInfo?.division,
    ],
    getFeedData
  );
  const hotPledges = useSWR<FormattedPoll[]>(
    [
      '/poll/hot/pledge',
      company?.companyID,
      dbUser?.postalInfo?.grc,
      dbUser?.postalInfo?.division,
    ],
    getHotPledgesData
  );
  const [getMore, setGetMore] = useState(false);

  // useLayoutEffect(() => {
  //   const el = document.getElementsByTagName('nav');
  //   if (el?.length) {
  //     el[0].style.display = 'none';
  //   }
  // }, []);
  const [hideNav, setHideNav] = useState(window.screen.width >= 1280);
  useEffect(() => {
    const el = document.getElementsByTagName('nav');
    if (el?.length) {
      el[0].style.display = hideNav ? 'none' : 'flex';
    }
  }, [hideNav]);

  // const voteTotal = (pollDetail: any) => {
  //   console.log(pollDetail);
  //   return (
  //     (pollDetail.poll?.voteCount || 0) +
  //     (pollDetail.subPolls
  //       ? pollDetail.subPolls.reduce((r, a) => {
  //           r += a?.voteCount || 0;
  //           return r;
  //         }, 0)
  //       : 0)
  //   );
  // };
  const sortPoll = (a, b) => {
    switch (sort) {
      case 1:
        // console.log(voteTotal(b), voteTotal(a));
        return b.voteCount < a.voteCount ? -1 : 1;
      case 2:
        // console.log(voteTotal(b), voteTotal(a));
        return a.title.toLowerCase() < b.title.toLowerCase() ? -1 : 1;
      case 3:
        // console.log(voteTotal(b), voteTotal(a));
        return b.title.toLowerCase() < a.title.toLowerCase() ? -1 : 1;

      default:
        return 1;
    }
  };

  const getCategory = async () => {
    try {
      const res = (await listIdeaCategorys([{ items: ['title', 'id'] }], {
        filter: {
          edu: {
            ne: true,
          },
        },
      })) as any;
      console.log('-------------', res?.data?.result);
      setCategories(res?.data?.result?.items || []);
    } catch (error) {
      console.log('clmmmmm', error);
    }
  };
  const go = debounce(() => {
    console.log('gogogo');
    setTyping(false);
  }, 1000);
  useEffect(() => {
    setTimeout(() => {
      getCategory();
    }, 1000);

    listMonth();
    return () => {
      const el = document.getElementsByTagName('nav');
      if (el?.length) {
        el[0].style.display = 'flex';
      }
    };
  }, []);

  return (
    <div className="idea-list bg-white flex flex-col items-center justify-start w-full">
      <div
        className="text-center flex flex-col items-center justify-start w-full bg-cover px-5"
        style={{
          background: `url(${top_bg})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center center',
          height: !!search
            ? window.screen.width > 1300
              ? '40vh'
              : '125vw'
            : window.screen.width > 1300
            ? '60vh'
            : '80vh',
          minHeight: !!search ? (window.screen.width > 1300 ? 355 : 300) : 500,
          paddingBottom: 50,
          transition: 'all 0.5s linear',
        }}
      >
        <div className={classes.cContainer}>
          <div
            className="flex flex-col lg:flex-row items-start"
            style={{
              justifyContent: 'flex-start',
              margin: '30px auto 10vw auto',
              maxWidth: 1356,
              width: '100%',
              gap: 50,
              padding: '0 40px',
            }}
          >
            {window.screen.width >= 1280 && (
              <>
                {dbUser && (
                  <img
                    src={ic_menu}
                    onClick={() => setHideNav(!hideNav)}
                    alt=""
                    style={{
                      width: 30,
                      height: 20,
                      marginRight: 10,
                      marginTop: 15,
                      cursor: 'pointer',
                    }}
                  />
                )}

                <img
                  src={logo}
                  alt="logo"
                  style={{ width: 150, marginTop: 10 }}
                />
              </>
            )}

            <div
              className="flex items-end"
              style={{
                flex: 1,
                flexWrap: 'wrap',
                gap: 20,
                marginTop: window.screen.width >= 1280 ? 0 : 50,
              }}
            >
              <button
                className={classes.cButton}
                onClick={() => {
                  history.push('/poll/create');
                }}
              >
                Create a Poll
              </button>
              <button
                className={classes.cButton}
                onClick={() => history.push('/feed')}
              >
                Cast a vote
              </button>
              <button
                className={classes.cButton}
                onClick={() => {
                  history.push('/poll/pledge');
                }}
              >
                Start New Pledge
              </button>
              <div
                style={{
                  borderBottom: 'solid 2px white',
                  flex: 1,

                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <FiSearch color="white" style={{ marginBottom: -10 }} />
                <InputText
                  value={search}
                  onChange={(e) => {
                    if (!typing) {
                      setTyping(true);
                      go();
                    }
                    setSearch(e);
                  }}
                  neon={true}
                  style={{ marginBottom: -10, minWidth: 200 }}
                  type="text"
                  shadow={false}
                  placeholder="Search for poll"
                />
              </div>
              {!dbUser && (
                <img
                  src={ic_login}
                  alt=""
                  style={{
                    width: 100,
                    height: 40,
                    marginTop: '20px',
                    marginLeft: 30,
                    cursor: 'pointer',
                  }}
                  onClick={() => history.push('/login')}
                />
              )}
            </div>
          </div>
          {/* <button
            className={classes.cButton}
            onClick={() => {
              history.push('/idea/create');
            }}
          >
            + Pledge
          </button>
          <img
            src={logo}
            className="w-[474px] mx-auto hidden xl:flex "
            style={{ marginTop: '49px' }}
            alt="logo"
          /> */}

          <p
            className={
              classes.searchTitle +
              ' text-white text-2xl font-bold ' +
              classes.borderText
            }
            style={{
              marginTop: !!search ? '-8vw' : 50,
              transition: 'all 0.5s linear',
            }}
          >
            {randomIndex > -1 && (
              <span
                dangerouslySetInnerHTML={{
                  __html: [
                    'Transform Your Ideas<br />Into Action',
                    'Easy polls for quick answers and goals',
                    'Experience the Next',
                  ][randomIndex],
                }}
              ></span>
            )}
          </p>
          {/* <p
            className={' text-white text-2xl font-bold '}
            style={{
              marginTop: 10,
              textShadow:
                'rgb(255, 70, 255) 1px 0px 0px, rgb(255, 70, 255) 0.540302px 0.841471px 0px, rgb(255, 70, 255) -0.416147px 0.909297px 0px, rgb(255, 70, 255) -0.989992px 0.14112px 0px, rgb(255, 70, 255) -0.653644px -0.756802px 0px, rgb(255, 70, 255) 0.283662px -0.958924px 0px, rgb(255, 70, 255) 0.96017px -0.279415px 0px',
            }}
          >
            Easy polls for quick answers and goals
          </p> */}
        </div>
      </div>
      <div
        style={{
          background: 'black',
          width: '100%',
        }}
      >
        <div
          className={classes.content}
          style={{ marginLeft: 'auto', marginRight: 'auto', padding: '25px' }}
        >
          <div className={classes.furetureTitle} style={{ color: 'white' }}>
            Pledges
          </div>
          <div
            className={classes.prodContainer + ' flex-wrap'}
            style={{ position: 'relative' }}
          >
            {(!hotPledges?.data ||
              !hotPledges?.data
                .filter((item, index) =>
                  item.title
                    .toUpperCase()
                    .trim()
                    .includes(search.toUpperCase().trim())
                )
                .filter((_, index) => index <= 3 || getMore).length) && (
              <h3
                style={{
                  color: 'white',
                  width: '100%',
                  textAlign: 'center',
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  fontSize: 30,
                  transform: 'translate(-50%,-50%)',
                }}
              >
                No Pledges Available
              </h3>
            )}
            {hotPledges?.data &&
              hotPledges?.data
                .filter((item, index) =>
                  item.title
                    .toUpperCase()
                    .trim()
                    .includes(search.toUpperCase().trim())
                )
                .filter((_, index) => index <= 3 || getMore)
                .map((item) => (
                  <div
                    key={item.id}
                    style={{
                      cursor: 'pointer',
                      marginBottom: 20,
                      position: 'relative',
                    }}
                    onClick={() => {
                      history.push('/poll/' + item.id);
                    }}
                  >
                    {item.hasPledge && (
                      <div
                        className="absolute z-1 w-12 h-12"
                        style={{ right: 20, bottom: 120 }}
                      >
                        <PollPledgeIcon color="animated" />
                      </div>
                    )}
                    <img
                      style={{ border: '3px solid white' }}
                      src={item?.image?.url || 'image'}
                      className={classes.prod}
                      alt="example"
                    />
                    <span
                      className={classes.prodTitle}
                      style={{
                        color: 'white',
                        marginTop: 10,
                      }}
                    >
                      <img
                        style={{
                          width: 25,
                          display: 'inline',
                        }}
                        src={ic_untick}
                        alt="icon_tick"
                      />
                      &nbsp; &nbsp;
                      {item.title}
                    </span>
                    <div
                      style={{
                        color: '#8e8e8d',
                        textAlign: 'center',
                        width: '100% !important',
                        marginTop: 5,
                      }}
                      className={classes.prodTime}
                    >
                      Starts &nbsp;
                      <span className="font-bold">
                        {format(item?.pledgePeriod1StartDate || 0, 'dd MMM')}
                      </span>{' '}
                      | Ends{' '}
                      <span className="font-bold">
                        {format(item?.pledgePeriod1EndDate || 0, 'dd MMM')}
                      </span>
                    </div>
                  </div>
                ))}
          </div>
          {!getMore && hotPledges.data && hotPledges?.data?.length > 4 && (
            <div className={'flex items-fenter justify-end font-bold mt-4'}>
              <div
                className={classes.prodTitle + ' underline cursor-pointer'}
                style={{ color: 'white' }}
                onClick={() => setGetMore(true)}
              >
                More
              </div>
            </div>
          )}
        </div>
      </div>

      <div className={classes.content}>
        <div
          className={`${classes.tag} mb-5 flex flex-wrap items-center justify-start gap-x-2 gap-y-4  w-full text-sm md:text-lg`}
          style={{
            flexWrap: 'wrap',
            marginTop: 50,
            columnGap: 10,
            padding: '0 10px',
          }}
        >
          {categories.map((item) => (
            <div
              onClick={() =>
                setSelectCategory({
                  ...selectCategory,
                  [item.title]: !selectCategory[item.title],
                })
              }
              style={{
                background: selectCategory?.[item.title] ? '#00ff43' : 'white',
                padding: '3px 21px',
                borderRadius: '22px',
                cursor: 'pointer',
                border: '1px solid black',
              }}
              key={item.id}
            >
              {item.title}
            </div>
          ))}
        </div>

        <div className="flex items-center">
          <div
            className={classes.furetureTitle}
            style={{ marginBottom: 0, marginRight: 20 }}
          >
            Polls
          </div>
          <select
            className={classes.sort}
            onChange={(e) => {
              setSort(+e.target.value || 0);
            }}
          >
            <option value={0}>Latest polls</option>
            <option value={1}>Popular polls</option>
            <option value={2}>A-Z polls</option>
            <option value={3}>Z-A Polls</option>
          </select>
          <select
            className={classes.sort + ' ml-4'}
            onChange={(e) => {
              setFilterDate(dates[e.target.value]);
            }}
          >
            {dates.map((item: any, i: number) => (
              <option key={item} value={i}>
                {format(new Date(item), 'MMM yyyy')}
              </option>
            ))}
          </select>
        </div>

        <div
          className={classes.prodContainer + ' flex-wrap'}
          style={{
            padding: '50px 0',
            position: 'relative',
          }}
        >
          {(!hotPoll?.data ||
            !hotPoll?.data.filter(
              (item) =>
                (item.title
                  .toUpperCase()
                  .trim()
                  .includes(search.toUpperCase().trim()) ||
                  (item.hashtag &&
                    ('#' + item.hashtag)
                      .toUpperCase()
                      .includes(search.toUpperCase().trim()))) &&
                (!Object.keys(selectCategory).filter(
                  (key) => selectCategory[key]
                ).length ||
                  (item.category && selectCategory[item.category]))
            ).length) && (
            <h3
              style={{
                color: 'black',
                width: '100%',
                textAlign: 'center',
                position: 'absolute',
                left: '50%',
                top: '40px',
                fontSize: 30,
                transform: 'translateX(-50%)',
              }}
            >
              No Polls Available
            </h3>
          )}
          {hotPoll?.data &&
            hotPoll?.data
              .filter(
                (item) =>
                  (item.title
                    .toUpperCase()
                    .trim()
                    .includes(search.toUpperCase().trim()) ||
                    (item.hashtag &&
                      ('#' + item.hashtag)
                        .toUpperCase()
                        .includes(search.toUpperCase().trim()))) &&
                  (!Object.keys(selectCategory).filter(
                    (key) => selectCategory[key]
                  ).length ||
                    (item.category && selectCategory[item.category]))
              )
              .sort(sortPoll)
              .map((item, i) => (
                <div
                  key={item.id}
                  style={{
                    cursor: 'pointer',
                    marginBottom: 20,
                    position: 'relative',
                  }}
                  onClick={() => {
                    history.push('/poll/' + item.id);
                  }}
                >
                  {item.hasPledge && (
                    <div
                      className="absolute z-1 w-12 h-12"
                      style={{ right: 20, bottom: 120 }}
                    >
                      <PollPledgeIcon color="animated" />
                    </div>
                  )}

                  <img
                    src={item?.image?.url || 'image'}
                    className={classes.prod}
                    alt="example"
                  />
                  <div
                    className={classes.prodTitle}
                    style={{
                      position: 'relative',
                      marginTop: 10,
                    }}
                  >
                    <img
                      style={{
                        display: 'inline',
                        width: 25,
                      }}
                      src={ic_tick}
                      alt="icon_tick1"
                    />
                    &nbsp; &nbsp;
                    {item.title}
                  </div>
                  <div
                    style={{
                      color: '#8e8e8d',
                      textAlign: 'center',
                      width: '100% !important',
                      marginTop: 5,
                    }}
                    className={classes.prodTime}
                  >
                    Starts &nbsp;
                    <span className="font-bold">
                      {format(item.startDate, 'dd MMM')}
                    </span>{' '}
                    | Ends{' '}
                    <span className="font-bold">
                      {format(item.endDate, 'dd MMM')}
                    </span>
                  </div>
                </div>
              ))}
        </div>
        <div className="w-full flex items-center mb-5">
          <div style={{ height: 2, width: '10%', background: '#0033ff' }}></div>
          <div style={{ height: 2, width: '40%', background: '#ffb400' }}></div>
          <div style={{ height: 2, width: '35%', background: '#ff46ff' }}></div>
          <div style={{ height: 2, width: '15%', background: '#8401ff' }}></div>
        </div>
        <div
          className="w-full flex items-center justify-center"
          style={{ gap: 20, flexWrap: 'wrap' }}
        >
          <div className="flex items-center" style={{ gap: 10 }}>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                background: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img alt="" src={ic_fb} style={{ width: 10 }} />
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                background: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img alt="" src={ic_tele} style={{ width: 20 }} />
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                background: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img alt="" src={ic_in} style={{ width: 15 }} />
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                background: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img alt="" src={ic_wat} style={{ width: 17 }} />
            </div>
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: '50%',
                background: 'black',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <img alt="" src={ic_gg} style={{ width: 15 }} />
            </div>
          </div>
          <div
            className="flex items-center justify-center"
            style={{ gap: 10, flexWrap: 'wrap' }}
          >
            <span>FAQ</span>
            <span>Contact US</span>
            <span>Report Abuse</span>
            <span>Terms and Conditions</span>
            <span>Privacy Policy</span>
            <span>Media Centre</span>
            <span>Investors</span>
            <span>About Us</span>
          </div>
          <div
            className="flex items-center justify-center"
            style={{ flexWrap: 'wrap' }}
          >
            <span>Mega X World:Mega X</span> &nbsp;|&nbsp;
            <span>NFT Ventures</span> &nbsp;|&nbsp;
            <span>Eduium</span>
          </div>
        </div>
        <div className="text-sm" style={{ textAlign: 'center', marginTop: 30 }}>
          2023 Mega X World LLP. All Rights Reserved
        </div>
      </div>
    </div>
  );
};
export default ListIdea;
